<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.foodPairing.create")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineReferentialForm
        :model="model"
        :item="item"
        resource="food-pairings"
        entity="food_pairings"
        group-field="category"
        :group-label="$t('intranet.referential.attributes.category')"
        :APIbaseURL="APIbaseURL"
      />
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular indeterminate :size="100" :width="10" color="secondary"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import AveineReferentialForm from '@/components/AveineReferentialForm.vue'
import FoodPairing from '@/store/models/food-pairing'

export default {
  name: 'Create',
  components: { AveineReferentialForm },
  data () {
    return {
      model: FoodPairing,
      item: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  async created () {
    this.item = await FoodPairing.new()
    this.item.$isNew = true
    // `name` est un objet de traductions et non une chaine : sans cette
    // initialisation, le v-model du formulaire ecrirait dans un undefined.
    this.item.name = {}
    this.dataLoaded = true
  }
}
</script>
